import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arm-details-form',
  templateUrl: './arm-details-form.component.html',
  styleUrls: ['./arm-details-form.component.css']
})
export class ArmDetailsFormComponent implements OnInit {
title="Arms Detail";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/arm-details/arm-details-form/arm-details-form.component.ts